import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const CreateAccountPrompt = () => {
  const navigate = useNavigate();

  return (
    <div className="mt-6 text-center">
      <p className="text-sm text-muted-foreground mb-3">
        Don't have an account?
      </p>
      <Button
        type="button"
        variant="outline"
        size="lg"
        fullWidth
        onClick={() => navigate('/register')}
        iconName="UserPlus"
        iconPosition="left"
      >
        Create Account
      </Button>
    </div>
  );
};

export default CreateAccountPrompt;